import { LoadPagePayload } from '../../pillar/common/actions/LoadPagePayload';

export class LoadEntityListPayload implements LoadPagePayload {
  page: number;
  pageSize: number;
  sort?: string;
  sortDirection?: string;
  searchTerm?: string;
  entityKey: string;
  scope: string;
  parentEntityKey?: string;
  parentKey?: string;
  showDeleted?: boolean;
}



// WEBPACK FOOTER //
// ./src/app/datawarehouse/models/LoadEntityListPayload.ts